import * as sentry from "@sentry/react";

import { buildDate } from "@/atoms/build-date";

sentry.init({
  dsn: import.meta.env.SENTRY_DSN,
  enabled: import.meta.env.SENTRY_ENABLED,
  initialScope: { tags: { buildDate } },
  integrations: [
    sentry.captureConsoleIntegration(),
    sentry.consoleLoggingIntegration(),
    sentry.contextLinesIntegration(),
    sentry.extraErrorDataIntegration(),
    sentry.httpClientIntegration(),
    sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    sentry.reportingObserverIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 1.0, // We may want to keep it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If we are not already sampling the entire session, we need to keep it 100% when sampling sessions where errors occur.
  profilesSampleRate: 1.0,
  environment: import.meta.env.SENTRY_ENV,
  release: import.meta.env.SENTRY_RELEASE,
  enableLogs: true,
});

export const Sentry = import.meta.env.SENTRY_ENABLED
  ? sentry
  : ({
      ...sentry,
      captureException(err, hint) {
        // eslint-disable-next-line no-console
        console.error(err, hint);
        return crypto.randomUUID();
      },
    } satisfies typeof sentry);
